import React, { useEffect } from 'react';
import { Testimonial } from './Testimonial';
import { ZapIcon } from 'lucide-react';
import { trackSectionView } from './MetaPixelTracker';
export function ReframeSection() {
  useEffect(() => {
    // Track section view when component mounts
    trackSectionView('ReframeSection');
  }, []);
  return <section className="py-16 border-b border-gray-800" data-id="element-470">
      <div className="max-w-3xl mx-auto" data-id="element-471">
        <h2 className="text-3xl font-bold mb-8 text-left" data-id="element-472">
          <span className="bg-gradient-to-r from-red-500 to-orange-500 text-transparent bg-clip-text" data-id="element-473">
            Te hicieron creer una mentira
          </span>
        </h2>
        <div className="space-y-6 mb-10" data-id="element-474">
          <p className="text-lg" data-id="element-475">
            Te hicieron creer que el problema eras vos. Que necesitabas
            pastillas. Que "así es la edad". Que es "normal".
          </p>
          <p className="text-xl font-bold text-red-500" data-id="element-476">Mentira.</p>
          <p className="text-lg" data-id="element-477">
            La verdad es que tu cuerpo recuerda. Solo necesita el estímulo
            correcto.
          </p>
          <p className="text-lg" data-id="element-478">
            Caminos naturales, potentes y milenarios. No farmacéuticos. No
            masivos.
          </p>
          <p className="text-lg mt-6" data-id="element-479">
            Sos el tipo que ella busca con la mirada. El que no pide permiso.
            Solo actúa. El que despierta algo salvaje… con solo entrar a la
            habitación.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-10" data-id="element-480">
          <Testimonial quote="Lo tomé sin decir nada… y ella lo notó. Me preguntó: '¿qué hiciste hoy?'" author="Lucas V." location="Palermo" imageSrc="https://images.unsplash.com/photo-1539571696357-5a69c17a67c6?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=774&q=80" testimonialId="testimonial_lucas" data-id="element-481" />
          <Testimonial quote="Volvimos a conectar con mi esposa como hacía años no pasaba. Más presente, más potente, más yo." author="Sergio F." location="Salta" imageSrc="https://images.unsplash.com/photo-1568602471122-7832951cc4c5?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1770&q=80" testimonialId="testimonial_sergio" data-id="element-482" />
        </div>
        <p className="text-xl font-semibold text-center mt-10" data-id="element-483">
          Ahora ya sabés. Y cuando sabés… algo cambia para siempre.
        </p>
        <div className="flex justify-center mt-10" data-id="element-484">
          <ZapIcon className="h-12 w-12 text-red-500" data-id="element-485" />
        </div>
      </div>
    </section>;
}